'use strict';

import template from '../../templates/employee/Layout.ejs';
import HeaderView from '../employee/LayoutHeader';
import ContentView from '../employee/LayoutContent';

import Employees from 'newCollections/employees.js';

module.exports = Backbone.View.extend({

    initialize: function(options) {
        Object.assign(this, options);
        this.headerView = new HeaderView({
            employees: []
        });

        this.contentView = new ContentView();
    },

    render: function() {
        const employees = new Employees(null, {
            company: app.company,
            pagination: false
        });
        employees.fetch({
            filter: {
                where: {
                    hiddenAt: null
                },
                limit: 9999
            }
        }).then(() => {
            this.headerView.setCollection(employees);
        });

        this.$el.html(template());

        this.headerView.setElement(this.$('.employee-edit-header'));
        this.headerView.render();

        this.contentView.setElement(this.$('.employee-edit-content'));
        this.contentView.render();

        return this;
    },

    // this is only to provide immediate feedback so user quickly sees selected tab
    renderTab: function(tab) {
        this.headerView.setModel(null);
        this.headerView.tab = tab;
        this.contentView.tab = tab;
        this.render();
    },

    // options must provide model property
    renderContent: function(options) {
        this.headerView.setModel(options.model);
        this.contentView.renderContent(options);
        if (options.employees) {
            this.headerView.setCollection(options.employees);
        }
    },

    hideLoader: function() {
        this.$('.js-loading-tab').removeClass('active');
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/employee/Layout.js